module.exports = __webpack_public_path__ + "img/digital-ads-performance-dark.001ed9eb.svg";